import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailTemplateDetailsRPC } from "./getEmailTemplateDetailsRPC";

export class GetEmailTemplateDetailsRPCClientImpl extends GetEmailTemplateDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailTemplateDetailsRPC.Request): Promise<LeoRPCResult<GetEmailTemplateDetailsRPC.Response, GetEmailTemplateDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailTemplateDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailTemplateDetailsRPC.ResponseDTO,
      GetEmailTemplateDetailsRPC.Errors.ErrorsDTO,
      GetEmailTemplateDetailsRPC.Response,
      GetEmailTemplateDetailsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailTemplateDetails",
      GetEmailTemplateDetailsRPC.Response.fromDTO,
      GetEmailTemplateDetailsRPC.Errors.fromDTO
    );
  }
}
